import React, { useContext } from "react";
import styled from "styled-components";

export const FilterButton = (props) => {
  const { context } = props; // Context passed as a prop

  // Dynamically choose the context based on the prop
  const { setFilter, filter, setSearchValue } = useContext(context);

  return (
    <StyledSelect
      name="filter"
      value={filter}
      onChange={(e) => {
        setFilter(e.target.value);
        setSearchValue(""); // Clear search value on filter change
      }}
    >
      <option value="">Filters</option>
      {props.showCallerName && <option value="caller_name">Caller Name</option>}
      {props.showCallerUserNmber && (
        <option value="user_number">Phone Number</option>
      )}
      {props.showAgentName && (
        <option value="agent_name">Prayer Partner</option>
      )}
      {props.showFollowupType && (
        <option value="follow_up_type">Follow up Type</option>
      )}
      {props.showOrganization && (
        <option value="twilio_number">Organization</option>
      )}
      {props.showTitle && <option value="title">Title</option>}
      {props.showDateRange && <option value="date_range">Date Range</option>}
    </StyledSelect>
  );
};

export default FilterButton;

const StyledSelect = styled.select`
  padding: 2px 8px;
  border: 2px solid #0d5e6d;
  border-radius: 30px;
  background-color: #0d5e6d;
  color: white;
  font-family: "Futura PT";
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.15em;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 35px;
  min-width: 140px;
  box-sizing: border-box;

  &:hover {
    background-color: #0a4a57;
  }

  option {
    background-color: white;
    color: #333;
    padding: 8px;
  }

  @media (min-width: 768px) {
    min-width: 160px;
    max-width: 200px;
  }
`;
